import type { MouseEvent, ReactNode } from "react";
import { Combobox } from "@headlessui/react";
import classNames from "classnames";

export interface OptionProps<T = unknown> {
  children?: ReactNode;
  className?: string;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
  option?: T;
}

export const Option = <T,>({
  option,
  children,
  className = "",
  ...rest
}: OptionProps<T>) => (
  <Combobox.Option
    className={({ active }) =>
      classNames(
        "text-dark relative cursor-pointer select-none px-5 py-2 text-sm",
        {
          "bg-secondary": active,
        },
        className,
      )
    }
    value={option}
    {...rest}
  >
    {children}
  </Combobox.Option>
);
